import toPairs from 'lodash/fp/toPairs'
import * as React from 'react'
import {connect} from 'react-redux'
import {Col, Label, Row} from 'reactstrap'
import * as Help from '../../../components/help'
import * as RasaInput from '../../../components/rasa-input'
import * as Reference from '../../reference'
import * as Sources from '../../sources'
import * as NewsbriefTypes from '../types'
import * as NewsbriefUtils from '../utils'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Utils from './utils'

interface LabelProps {
  configKey: string,
}

const HelpLabel = ({configKey}: LabelProps) => {
  const helpKey = Utils.helpKeyFor(configKey)
  return <Col sm="2" className="text-left">
    <Label className="field-label">
      <span className="field-label-text">{Utils.labelFor(configKey)}</span>
      <Help.Help helpType={helpKey} id={helpKey} />
    </Label>
  </Col>
}

interface CounterProps {
  config: NewsbriefTypes.ConfigurationRow,
  configKey: string,
  partnerCode: string,
  updateCount: NewsbriefTypes.StateUpdateActionCreator,
}

const Counter = ({configKey, config, updateCount, partnerCode}: CounterProps) => {
  return <Col sm="2" className="text-left">
    <RasaInput.RasaNumericInput
      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        updateCount({
          name: configKey,
          partnerCode,
          property: 'value',
          rowId: config ? config.rowId : '',
          value: e.target.value,
        })}
      value={config ? config.data.value || '' : ''}/>
  </Col>
}

interface DispatchProps {
  selectedPartner: string,
  sources: Sources.SourcesDataState,
  updateCount: NewsbriefTypes.StateUpdateActionCreator,
}
type Props = DispatchProps & NewsbriefTypes.WrappedConfigurationRows & Reference.WrappedState

const Counts =
  ({rows, sources, referenceData, selectedPartner, updateCount}: Props & NewsbriefTypes.WrappedConfigurationRows) => {
  return <div className="newsbrief-counts">
  <Row>
    <Col sm="2"><label className="field-label"></label></Col>
    {Constants.ALL_CONTENT_KEYS.map((k: string) => {
      return <HelpLabel key={k} configKey={k}/>
    })}
  </Row>
  {(referenceData.categories || [])
             .filter((c: Reference.ReferenceData) => sources.length === 0 || Sources.byCategory(sources, c).length > 0)
             .map((c: Reference.ReferenceData) => (
  <Row key={c.id}>
    <Col sm="2"><label className="field-label">{c.display_name} Limits</label></Col>
    {Constants.categoryKeys(c.name).map((k: string) => {
      return <Counter key={k}
                      configKey={k}
                      config={NewsbriefUtils.findConfig(k, selectedPartner, rows)}
                      updateCount={updateCount}
                      partnerCode={selectedPartner}/>
                })}
  </Row>))}
</div>}

type ConnectedState = Sources.WrappedState & NewsbriefTypes.WrappedState & Reference.WrappedState
export const CountsConnected = connect(
  ({newsbriefConfigs, sources, referenceData}: ConnectedState) => ({
    referenceData,
    rows:
      toPairs(newsbriefConfigs.counts)
        .map(([rowId, {data, editing}]: [string, NewsbriefTypes.Row<NewsbriefTypes.PayloadData>]) =>
          ({rowId, data, editing}))
        .filter(({rowId, data, editing}) =>
          data.is_active &&
          NewsbriefUtils.isSelectedPartner(data.partner_code, newsbriefConfigs.configState.selectedPartner)),
    selectedPartner: newsbriefConfigs.configState.selectedPartner,
    sources: sources.data,
  }),
  { updateCount: Actions.updateCount },
)(Counts)



// WEBPACK FOOTER //
// ./src/pages/newsbrief/counts/component.tsx